module.exports = __webpack_public_path__ + "static/media/saving_investment.5e2e533f.svg";